import { tokens } from '@ping/design-tokens';

export interface Motion {
  duration: {
    instant: number;
    fast: number;
    standard: number;
    moderate: number;
    slow: number;
  };
  easing: {
    standard: string;
    accelerate: string;
    decelerate: string;
  };
}

export const motion: Motion = {
  duration: {
    instant: tokens.motion.duration.instant,
    fast: tokens.motion.duration.fast,
    standard: tokens.motion.duration.standard,
    moderate: tokens.motion.duration.moderate,
    slow: tokens.motion.duration.slow,
  },
  easing: {
    standard: tokens.motion.easing.standard,
    accelerate: tokens.motion.easing.accelerate,
    decelerate: tokens.motion.easing.decelerate,
  },
};
